<template>
  <div class="flex">
    <div class="edit-link mr-8 cursor-pointer" @click="gotToEditPage(params.data.id)">Edit</div>
    <div class="delete-link cursor-pointer" @click="showDeleteConfirmation(params.data.id)">Remove</div>

    <div>
      <speakol-confirmation-popup v-on:hide-confirmation-popup="deletionConfirmationPopup.show = false"
        v-on:confirm="deleteAudience(params.data.id)" :showConfirmationPopup="deletionConfirmationPopup.show"
        :confirmationText="deletionConfirmationPopup.confirmationText">

        <template v-slot:body>
          <p class="mt-2">
                Are you sure you want to remove <strong>{{ params.data.name }} audience </strong>from your saved list ?
          </p>
        </template>
      </speakol-confirmation-popup>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      deletionConfirmationPopup: {
        show: false
      }
    }
  },
  methods: {
    gotToEditPage (audienceId) {
      this.$router.push(`/targeting/audiences/edit/${audienceId}`)
    },

    showDeleteConfirmation () {
      this.deletionConfirmationPopup.show = true
    },

    async deleteAudience (audienceId) {
      const {
        data
      } = await window.axios.delete('/audience', {
        data: {
          audiences_ids: [audienceId]
        }
      })
      const isDeleted = data && data.payload
      if (isDeleted) {
        this.deletionConfirmationPopup.show = false
        this.params.context.parent.$emit('AUDIENCE_DELETED', this.params.data.name)
      }
    }
  }
}

</script>


<style lang="scss" scoped>
  /deep/ .prompt-title {
    display: none;
  }

  .edit-link {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 21px;
    color: #0092d7;
  }

  .delete-link {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 21px;
    color: #db2828;
  }

</style>
